export default __webpack_public_path__ + "static/media/logo_cinfo.e698cd41.svg";